import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

// Get Branch Summary Report Details
export const getBranchSummaryReportDetails = (fetchData: any) => {
	const data = {
		GetBranchSummaryReportDetailsToken: fetchData,
	};
	const url = `${API_URL}fetchBranchSummaryReport`;
	return makeApiCall(url, data);
};
